
class ApiClient {
  constructor() {
    this.baseURL = process.env.REACT_APP_BACKEND_API_URL;
    this.apiKey = process.env.REACT_APP_API_KEY;
  }

  _buildHeaders(additionalHeaders = {}, isFormData = false) {
    const headers = {
      'x-api-key': this.apiKey,
      ...additionalHeaders,
    };
    
    if (!isFormData && !headers['Content-Type']) {
      headers['Content-Type'] = 'application/json';
    }
    
    return headers;
  }

  async _handleError(response) {
    let errorData;
    try {
      const text = await response.text();
      try {
        errorData = JSON.parse(text);
      } catch (e) {
        // If JSON parsing fails, use the text as error message
        errorData = { error: text || `HTTP ${response.status}: ${response.statusText}` };
      }
    } catch (e) {
      errorData = { error: `HTTP ${response.status}: ${response.statusText}` };
    }
    
    // Extract error message from various possible formats
    const errorMessage = errorData.error || errorData.message || errorData.detail || errorData.msg || 
                        (typeof errorData === 'string' ? errorData : `HTTP ${response.status}: ${response.statusText}`);
    
    return { ...errorData, error: errorMessage };
  }

  async uploadFile(file, folder = 'temp') {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const url = folder 
        ? `${this.baseURL}/s3/upload?folder=${encodeURIComponent(folder)}`
        : `${this.baseURL}/s3/upload`;

      const response = await fetch(url, {
        method: 'POST',
        headers: this._buildHeaders({}, true),
        body: formData,
      });

      if (!response.ok) {
        const errorData = await this._handleError(response);
        console.error('❌ Upload failed:', {
          status: response.status,
          statusText: response.statusText,
          errorData,
          fileSize: file.size,
          fileName: file.name
        });
        
        // Extract error message - backend might return "too large" or similar
        let errorMessage = errorData.error || `Upload failed: ${response.status} ${response.statusText}`;
        
        // Check for common file size error messages
        if (errorMessage.toLowerCase().includes('too large') || 
            errorMessage.toLowerCase().includes('file size') ||
            errorMessage.toLowerCase().includes('exceed') ||
            response.status === 413) {
          errorMessage = `Dosya boyutu çok büyük. Backend limiti: ${errorMessage}`;
        }
        
        return {
          success: false,
          error: errorMessage,
        };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API upload error:', error);
      return {
        success: false,
        error: error.message || 'Network error',
      };
    }
  }

  async uploadContractPDF(file, contractId) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const url = `${this.baseURL}/s3/upload/contract-pdf/${contractId}`;
      const headers = this._buildHeaders({}, true);
      
      console.log('📤 Upload Contract PDF:', {
        url,
        contractId,
        fileName: file.name,
        fileSize: file.size,
        hasApiKey: !!headers['x-api-key']
      });

      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: formData,
      });

      console.log('📥 Response:', response.status, response.statusText);

      if (!response.ok) {
        const errorData = await this._handleError(response);
        console.error('❌ Upload failed:', {
          status: response.status,
          statusText: response.statusText,
          errorData,
          fileSize: file.size,
          fileName: file.name
        });
        
        // Extract error message - backend might return "too large" or similar
        let errorMessage = errorData.error || `Upload failed: ${response.status} ${response.statusText}`;
        
        // Check for common file size error messages
        if (errorMessage.toLowerCase().includes('too large') || 
            errorMessage.toLowerCase().includes('file size') ||
            errorMessage.toLowerCase().includes('exceed') ||
            response.status === 413) {
          errorMessage = `Dosya boyutu çok büyük. Backend limiti: ${errorMessage}`;
        }
        
        return {
          success: false,
          error: errorMessage,
        };
      }

      const data = await response.json();
      console.log('✅ Upload success:', data);
      return data;
    } catch (error) {
      console.error('❌ API upload error:', error);
      return {
        success: false,
        error: error.message || 'Network error',
      };
    }
  }


  async uploadProtocolPDF(file, contractId) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(
        `${this.baseURL}/s3/upload/protocol-pdf/${contractId}`,
        {
          method: 'POST',
          headers: this._buildHeaders({}, true),
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await this._handleError(response);
        console.error('❌ Upload failed:', {
          status: response.status,
          statusText: response.statusText,
          errorData,
          fileSize: file.size,
          fileName: file.name
        });
        
        // Extract error message - backend might return "too large" or similar
        let errorMessage = errorData.error || `Upload failed: ${response.status} ${response.statusText}`;
        
        // Check for common file size error messages
        if (errorMessage.toLowerCase().includes('too large') || 
            errorMessage.toLowerCase().includes('file size') ||
            errorMessage.toLowerCase().includes('exceed') ||
            response.status === 413) {
          errorMessage = `Dosya boyutu çok büyük. Backend limiti: ${errorMessage}`;
        }
        
        return {
          success: false,
          error: errorMessage,
        };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API upload error:', error);
      return {
        success: false,
        error: error.message || 'Network error',
      };
    }
  }

  async uploadOfferPDF(file, offerId) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(
        `${this.baseURL}/s3/upload/offer-pdf/${offerId}`,
        {
          method: 'POST',
          headers: this._buildHeaders({}, true),
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await this._handleError(response);
        console.error('❌ Upload failed:', {
          status: response.status,
          statusText: response.statusText,
          errorData,
          fileSize: file.size,
          fileName: file.name
        });
        
        // Extract error message - backend might return "too large" or similar
        let errorMessage = errorData.error || `Upload failed: ${response.status} ${response.statusText}`;
        
        // Check for common file size error messages
        if (errorMessage.toLowerCase().includes('too large') || 
            errorMessage.toLowerCase().includes('file size') ||
            errorMessage.toLowerCase().includes('exceed') ||
            response.status === 413) {
          errorMessage = `Dosya boyutu çok büyük. Backend limiti: ${errorMessage}`;
        }
        
        return {
          success: false,
          error: errorMessage,
        };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API upload error:', error);
      return {
        success: false,
        error: error.message || 'Network error',
      };
    }
  }

  async uploadRevisedOfferPDF(file, offerId) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(
        `${this.baseURL}/s3/upload/revised-offer-pdf/${offerId}`,
        {
          method: 'POST',
          headers: this._buildHeaders({}, true),
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await this._handleError(response);
        console.error('❌ Upload failed:', {
          status: response.status,
          statusText: response.statusText,
          errorData,
          fileSize: file.size,
          fileName: file.name
        });
        
        // Extract error message - backend might return "too large" or similar
        let errorMessage = errorData.error || `Upload failed: ${response.status} ${response.statusText}`;
        
        // Check for common file size error messages
        if (errorMessage.toLowerCase().includes('too large') || 
            errorMessage.toLowerCase().includes('file size') ||
            errorMessage.toLowerCase().includes('exceed') ||
            response.status === 413) {
          errorMessage = `Dosya boyutu çok büyük. Backend limiti: ${errorMessage}`;
        }
        
        return {
          success: false,
          error: errorMessage,
        };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API upload error:', error);
      return {
        success: false,
        error: error.message || 'Network error',
      };
    }
  }

  async uploadJobCommissionDocument(file, jobId) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(
        `${this.baseURL}/s3/upload/job-commission-document/${jobId}`,
        {
          method: 'POST',
          headers: this._buildHeaders({}, true),
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await this._handleError(response);
        console.error('❌ Upload failed:', {
          status: response.status,
          statusText: response.statusText,
          errorData,
          fileSize: file.size,
          fileName: file.name
        });
        
        // Extract error message - backend might return "too large" or similar
        let errorMessage = errorData.error || `Upload failed: ${response.status} ${response.statusText}`;
        
        // Check for common file size error messages
        if (errorMessage.toLowerCase().includes('too large') || 
            errorMessage.toLowerCase().includes('file size') ||
            errorMessage.toLowerCase().includes('exceed') ||
            response.status === 413) {
          errorMessage = `Dosya boyutu çok büyük. Backend limiti: ${errorMessage}`;
        }
        
        return {
          success: false,
          error: errorMessage,
        };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API upload error:', error);
      return {
        success: false,
        error: error.message || 'Network error',
      };
    }
  }

  async uploadJobFirstPhaseDocument(file, jobId) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(
        `${this.baseURL}/s3/upload/job-first-phase-document/${jobId}`,
        {
          method: 'POST',
          headers: this._buildHeaders({}, true),
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await this._handleError(response);
        console.error('❌ Upload failed:', {
          status: response.status,
          statusText: response.statusText,
          errorData,
          fileSize: file.size,
          fileName: file.name
        });
        
        // Extract error message - backend might return "too large" or similar
        let errorMessage = errorData.error || `Upload failed: ${response.status} ${response.statusText}`;
        
        // Check for common file size error messages
        if (errorMessage.toLowerCase().includes('too large') || 
            errorMessage.toLowerCase().includes('file size') ||
            errorMessage.toLowerCase().includes('exceed') ||
            response.status === 413) {
          errorMessage = `Dosya boyutu çok büyük. Backend limiti: ${errorMessage}`;
        }
        
        return {
          success: false,
          error: errorMessage,
        };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API upload error:', error);
      return {
        success: false,
        error: error.message || 'Network error',
      };
    }
  }

  async deleteFile(key) {
    try {
      const response = await fetch(`${this.baseURL}/s3/file`, {
        method: 'DELETE',
        headers: this._buildHeaders({ 'Content-Type': 'application/json' }, false),
        body: JSON.stringify({ key }),
      });

      if (!response.ok) {
        const errorData = await this._handleError(response);
        return {
          success: false,
          error: errorData.error || 'Delete failed',
        };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('API delete error:', error);
      return {
        success: false,
        error: error.message || 'Network error',
      };
    }
  }

  async getSignedUrl(key, expiresIn = 3600, filename = null) {
    try {
      if (!key) {
        console.error('getSignedUrl: key is required');
        return null;
      }
      const encodedKey = encodeURIComponent(key);
      const expiresInStr = String(expiresIn);

      let url = `${this.baseURL}/s3/signed-url?key=${encodedKey}&expiresIn=${expiresInStr}`;
      // Opsiyonel `filename` — backend Content-Disposition ekleyerek dosyayi
      // orijinal adiyla indirtir (S3 key'i uuid-mangled olsa bile).
      if (filename) {
        url += `&filename=${encodeURIComponent(filename)}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: this._buildHeaders({}, false),
      });

      if (!response.ok) {
        const errorData = await this._handleError(response);
        console.error('Signed URL error:', errorData);
        return null;
      }
      const data = await response.json();
      return data.url || null;
    } catch (error) {
      console.error('API signed URL error:', error);
      return null;
    }
  }

  // Dosyayi backend proxy uzerinden Blob olarak indirir. Browser dogrudan
  // S3'e gitmez — kurumsal firewall/antivirusun amazonaws.com'u kestigi
  // ortamlarda da calisir.
  async downloadFileAsBlob(key, filename = null) {
    try {
      if (!key) {
        console.error('downloadFileAsBlob: key is required');
        return null;
      }
      let url = `${this.baseURL}/s3/download?key=${encodeURIComponent(key)}`;
      if (filename) {
        url += `&filename=${encodeURIComponent(filename)}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: this._buildHeaders({}, true),
      });

      if (!response.ok) {
        const errorData = await this._handleError(response);
        console.error('Download error:', errorData);
        return null;
      }
      return await response.blob();
    } catch (error) {
      console.error('API download error:', error);
      return null;
    }
  }
}

export default new ApiClient();
